import { render, staticRenderFns } from "./Ssn.vue?vue&type=template&id=badd5b92&scoped=true&"
import script from "./Ssn.vue?vue&type=script&lang=js&"
export * from "./Ssn.vue?vue&type=script&lang=js&"
import style0 from "./Ssn.vue?vue&type=style&index=0&id=badd5b92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badd5b92",
  null
  
)

export default component.exports